export default __webpack_public_path__ + "static/media/food-plan.73954983.png";